import { createSlice } from '@reduxjs/toolkit'
import { getStudentCourse } from '../../builders/studentCourse/studentCourse.builder'
import { createPracticeExam, getStudentDashboard } from '../../builders/studentCourse/studentCourseDashboard.builder'

const initialState = {
  studentCourseData: [],
  studentDashboardData: [],
  studentPracticeExamData: [],
}

const studentCourseSlice = createSlice({
  name: 'studentCourse',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getStudentCourse.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getStudentCourse.fulfilled, (state, action) => {
      state.studentCourseData = action.payload
      state.loading = false
    })
    builder.addCase(getStudentCourse.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getStudentDashboard.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getStudentDashboard.fulfilled, (state, action) => {
      state.studentDashboardData = action.payload
      state.loading = false
    })
    builder.addCase(getStudentDashboard.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(createPracticeExam.pending, (state) => {
      state.loading = true
    })
    builder.addCase(createPracticeExam.fulfilled, (state, action) => {
      state.studentPracticeExamData = action.payload
      state.loading = false
    })
    builder.addCase(createPracticeExam.rejected, (state) => {
      state.loading = false
    })
  },
})

export const { studentCourseData, studentDashboardData, studentPracticeExamData } = studentCourseSlice.actions

export default studentCourseSlice.reducer
